import { ThunkType } from "../../../../core/store/reducers";
import { createOrderApi } from "../api/createOrder";
import { updateOrderApi } from "../api/updateOrder";
import { modifyOrderApi } from "../api/modifyOrder";
import { oppositeOrderApi } from "../api/oppositeOrder";
import { setNewOrderFetchState, invalidateOrders } from "../../mainBoard/ordersDataSlice";
import { EditOrder, OrdersEditAction, OrderUpsertResult } from "../types";

export const upsertOrder = (
	action: OrdersEditAction,
	order: EditOrder
): ThunkType<Promise<OrderUpsertResult>> => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return {
			status: "ERROR",
			message: "USER NOT LOGED IN!",
		};
	}

	dispatch(setNewOrderFetchState({ type: "started" }));

	var { user } = store.data.auth.current;
	const result =
		action === OrdersEditAction.Modify ? await dispatch(modifyOrderApi(order, user.userId))
			: action === OrdersEditAction.Verify ? await dispatch(updateOrderApi(order, user.userId))
			: action === OrdersEditAction.New ? await dispatch(createOrderApi(order))
			: await dispatch(oppositeOrderApi(order));

	if (result && result.resCode === "OK") {
		dispatch(setNewOrderFetchState({ type: "successful", result: result.resDesc }));
		dispatch(invalidateOrders());
		return {
			status: "CREATED",
			newId: result.resDesc,
		};
	} else if (result && result.resCode === "NOFUNDS") {
		dispatch(setNewOrderFetchState({ type: "not-started" }));
		return {
			status: "NOFUNDS",
			message: result.resDesc,
		};
	} else {
		dispatch(setNewOrderFetchState({ type: "error", errorCode: result?.resCode }));
		return {
			status: "ERROR",
			message: result?.resCode,
		};
	}
};
